var _rect, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCancelledicon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    rx: 10,
    fill: "#FF0000"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.2186 6.93289C7.86357 6.57787 7.28793 6.57787 6.9329 6.93289C6.57787 7.28791 6.57787 7.86352 6.9329 8.21854L8.71436 9.99997L6.9329 11.7814C6.57799 12.1364 6.57799 12.712 6.9329 13.067C7.28793 13.422 7.86357 13.422 8.2186 13.067L10.0001 11.2856L11.7814 13.067C12.1364 13.422 12.7121 13.422 13.0671 13.067C13.4221 12.712 13.4221 12.1364 13.0671 11.7814L11.2856 9.99997L13.0671 8.21856C13.4221 7.86353 13.4221 7.28793 13.0671 6.93291C12.7121 6.57788 12.1364 6.57788 11.7814 6.93291L10.0001 8.71432L8.2186 6.93289Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCancelledicon);
export default __webpack_public_path__ + "static/media/cancelled.icon.b990fc61da614042efd59a28c512fdab.svg";
export { ForwardRef as ReactComponent };